import { getBaseDomain } from '@skyeng/libs/shared/misc';

export const baseDomain = getBaseDomain();

export const environmentCustom = {
  production: true,
  sentry: {
    enabled: true,
    dsn: "<erb= ENV.fetch('SENTRY_DSN', '') erb>",
    release: "<erb= ENV.fetch('SENTRY_RELEASE', '') erb>",
  },
  tracking: {
    skyengKey: 'kiegh5ahd3bee7Poh9pieyuef7oqu0eehooWeemoaNi',
  },
};
